<template>
  <project-base :state="state">
    <div class="container flex flex-wrap">
      <app-card class="w-full lg:w-1/2 mx-auto my-12">
        <div
          class="max-w-md mx-auto mt-6"
          style="display: grid; gap: 2rem; grid-template-columns: min-content 1fr; align-items: center;"
        >
          <svg
            v-if="current"
            viewBox="0 0 100 100"
            xmlns="http://www.w3.org/2000/svg"
            class="w-32 h-32"
          >
            <path
              d="M10 50a40 40 0 1 0 80 0 40 40 0 1 0 -80 0Z"
              fill="#ccf3f9"
              stroke-width="1"
            ></path>
            <path
              d="M67.079 38.564 51.858 18.046a2.2 2.2 0 0 0 -3.716 0L32.921 38.564"
              fill="none"
              stroke="#021316"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1"
            ></path>
            <path
              d="M47.473 17.801a2.527 2.527 0 1 0 5.054 0 2.527 2.527 0 1 0 -5.054 0Z"
              fill="#ffffff"
              stroke="#021316"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1"
            ></path>
            <path
              d="M34.462 80.449a15.538 1.902 0 1 0 31.076 0 15.538 1.902 0 1 0 -31.076 0Z"
              fill="#5edaed"
              stroke-width="1"
            ></path>
            <path
              d="m23.356 35.165 53.287 0 0 34.912 -53.287 0Z"
              fill="#5edaed"
              stroke-width="1"
            ></path>
            <path
              d="m23.356 35.165 53.287 0 0 34.912 -53.287 0Z"
              fill="none"
              stroke="#021316"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1"
            ></path>
            <path
              d="M34.023 59.786a4.709 4.709 0 0 1 -4.705 -4.7v-4.84a4.7 4.7 0 1 1 9.409 0v4.836a4.709 4.709 0 0 1 -4.704 4.704Zm0 -10.737a1.2 1.2 0 0 0 -1.2 1.2v4.836a1.2 1.2 0 0 0 2.394 0v-4.839a1.2 1.2 0 0 0 -1.194 -1.197Z"
              fill="#ffffff"
              stroke="#021316"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1"
            ></path>
            <path
              d="M52.781 59.786a1.754 1.754 0 0 1 -1.753 -1.753V47.3a1.755 1.755 0 0 1 1.753 -1.754h5.1a1.754 1.754 0 0 1 0 3.508h-3.347v1.856h3.347a1.754 1.754 0 1 1 0 3.507h-3.347v1.862h3.347a1.754 1.754 0 1 1 0 3.507Z"
              fill="#ffffff"
              stroke="#021316"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1"
            ></path>
            <path
              d="M68.928 59.786a1.755 1.755 0 0 1 -1.534 -0.9l-2.661 -4.8v3.955a1.754 1.754 0 0 1 -3.508 0V47.3a1.754 1.754 0 0 1 3.288 -0.85l2.661 4.805v-4.043a1.754 1.754 0 0 1 3.508 0v10.821a1.756 1.756 0 0 1 -1.754 1.753Z"
              fill="#ffffff"
              stroke="#021316"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1"
            ></path>
            <path
              d="M42.072 59.786a1.755 1.755 0 0 1 -1.754 -1.753V47.3a1.745 1.745 0 0 1 1.482 -1.738 10.768 10.768 0 0 1 1.556 -0.108 7.084 7.084 0 0 1 4.561 1.385 4.7 4.7 0 0 1 0 6.911 6.63 6.63 0 0 1 -4.094 1.371v2.912a1.754 1.754 0 0 1 -1.751 1.753Zm1.753 -8.167a3.23 3.23 0 0 0 1.814 -0.534 1.228 1.228 0 0 0 0 -1.585 3.227 3.227 0 0 0 -1.812 -0.528Z"
              fill="#ffffff"
              stroke="#021316"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1"
            ></path>
          </svg>
          <svg
            v-else
            viewBox="0 0 100 100"
            xmlns="http://www.w3.org/2000/svg"
            class="w-32 h-32"
          >
            <path
              d="M10 50a40 40 0 1 0 80 0 40 40 0 1 0 -80 0Z"
              fill="#ccf3f9"
              stroke-width="1"
            ></path>
            <path
              d="M67.079 38.564 51.858 18.046a2.2 2.2 0 0 0 -3.716 0L32.921 38.564"
              fill="none"
              stroke="#021316"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1"
            ></path>
            <path
              d="M47.473 17.801a2.527 2.527 0 1 0 5.054 0 2.527 2.527 0 1 0 -5.054 0Z"
              fill="#ffffff"
              stroke="#021316"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1"
            ></path>
            <path
              d="M34.462 80.449a15.538 1.902 0 1 0 31.076 0 15.538 1.902 0 1 0 -31.076 0Z"
              fill="#5edaed"
              stroke-width="1"
            ></path>
            <path
              d="m23.356 35.165 53.288 0 0 34.912 -53.288 0Z"
              fill="#5edaed"
              stroke-width="1"
            ></path>
            <path
              d="m23.356 35.165 53.288 0 0 34.912 -53.288 0Z"
              fill="none"
              stroke="#021316"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1"
            ></path>
            <path
              d="M34.864 59.513c-2.557 0 -7.394 -1.44 -7.394 -6.891s4.837 -6.891 7.394 -6.891a1.819 1.819 0 0 1 0.007 3.638c-0.625 0.006 -3.761 0.188 -3.761 3.253 0 3.1 3.127 3.253 3.754 3.253a1.819 1.819 0 1 1 0 3.638Z"
              fill="#ffffff"
              stroke="#021316"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1"
            ></path>
            <path
              d="M56.959 59.513a1.819 1.819 0 0 1 0 -3.638h1.615a1.025 1.025 0 0 0 1.026 -1.024 0.41 0.41 0 0 0 -0.409 -0.41 4.053 4.053 0 0 1 -4.048 -4.048 4.666 4.666 0 0 1 4.657 -4.662h1.615a1.819 1.819 0 1 1 0 3.638H59.8a1.024 1.024 0 0 0 -1.022 1.024 0.41 0.41 0 0 0 0.409 0.41 4.053 4.053 0 0 1 4.048 4.048 4.667 4.667 0 0 1 -4.662 4.662Z"
              fill="#ffffff"
              stroke="#021316"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1"
            ></path>
            <path
              d="M39.047 59.513a1.821 1.821 0 0 1 -1.82 -1.819V47.55a1.82 1.82 0 0 1 3.639 0v8.325h2.639a1.819 1.819 0 1 1 0 3.638Z"
              fill="#ffffff"
              stroke="#021316"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1"
            ></path>
            <path
              d="M49.99 59.513a4.613 4.613 0 0 1 -4.607 -4.607v-4.569a4.606 4.606 0 1 1 9.212 0v4.569a4.612 4.612 0 0 1 -4.605 4.607Zm0 -10.144a0.969 0.969 0 0 0 -0.968 0.968v4.569a0.968 0.968 0 1 0 1.935 0v-4.569a0.969 0.969 0 0 0 -0.967 -0.968Z"
              fill="#ffffff"
              stroke="#021316"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1"
            ></path>
            <path
              d="M65.893 59.513a1.821 1.821 0 0 1 -1.818 -1.819V47.55a1.821 1.821 0 0 1 1.818 -1.819h4.817a1.819 1.819 0 1 1 0 3.638h-3V50.8h3a1.819 1.819 0 1 1 0 3.638h-3v1.434h3a1.819 1.819 0 1 1 0 3.638Z"
              fill="#ffffff"
              stroke="#021316"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1"
            ></path>
          </svg>
          <div>
            <h2>
              {{
                current ? "Claim's window is open" : "Claim's window is closed"
              }}
            </h2>
            <p v-if="!current">
              The next claims window opens in {{ next.days_until_open }} days
            </p>
            <p v-else>
              This claims window closes in {{ current.days_until_closing }} days
            </p>
          </div>
        </div>
        <h3 class="px-4 text-sm mt-8 pb-1 text-grey-700 border-b">
          Schedule
        </h3>
        <div
          style="display: grid; grid-template-columns: 2rem 1fr 1.5fr 10rem; column-gap: 1rem;"
        >
          <data-provider
            v-for="(entry, index) in entries"
            :key="entry.open_date_schedule"
            v-slot="{ data: { hasClaim, badge, classes } }"
            :source="entryState(entry)"
          >
            <component
              :is="entry.claim_window_open || hasClaim ? 'a' : 'aside'"
              :href="entry.claim_window_open || hasClaim ? route('projects.claim.show', { project: state.project.uuid, claim_path: entry.claim_period_path }) : null"
              :class="['text-sm items-center w-full px-4 py-2 no-underline text-black', {
                'border-b border-grey-200': index < entries.length - 1,
              }, classes.row]"
              style="display: grid; grid-template-columns: subgrid; grid-column: 1 / -1;"
            >
              <div>
                <span
                  v-if="entry.is_open"
                  :class="['text-lg font-bold', classes.text]"
                >
                  &rightarrow;
                </span>
              </div>
              <h3>
                {{ format(parseISO(entry.open_date_schedule), "dd/MM/yyyy") }} -
                {{ format(parseISO(entry.closing_date_schedule), "dd/MM/yyyy") }}
              </h3>
              <p v-html="scheduleDescription(entry)" />
              <app-badge
                :type="badge.type"
                class="ml-auto"
                slot-classes="py-1"
              >
                {{ badge.text }}
              </app-badge>
            </component>
          </data-provider>
        </div>
      </app-card>
    </div>
  </project-base>
</template>

<script>
/**
 * A claim entry object representing a claim period.
 * @typedef {Object} ClaimEntry
 * @property {number} id
 * @property {string} claim_period_path
 * @property {boolean} claim_window_open
 * @property {number} competition_project_id
 * @property {number} competition_project_partner_id
 * @property {number} competition_monitoring_item_id
 * @property {string} open_date
 * @property {string} first_reminder_date
 * @property {string} second_reminder_date
 * @property {string} third_reminder_date
 * @property {string} closing_date
 * @property {number} requires_claim_review
 * @property {number} requires_monitor_feedback
 * @property {number} requires_msp_feedback
 * @property {null} partner_status
 * @property {null} partner_feedback
 * @property {null} partner_monitoring_by
 * @property {null} partner_monitoring_at
 * @property {number} partner_monitoring_completed
 * @property {null} monitor_status
 * @property {null} monitor_feedback
 * @property {null} monitor_monitoring_by
 * @property {null} monitor_monitoring_at
 * @property {number} monitor_monitoring_completed
 * @property {null} msp_status
 * @property {null} msp_feedback
 * @property {null} msp_monitoring_by
 * @property {null} msp_monitoring_at
 * @property {number} msp_monitoring_completed
 * @property {string} created_at
 * @property {string} updated_at
 * @property {string} open_date_schedule
 * @property {string} closing_date_schedule
 * @property {boolean} is_open
 * @property {number} days_until_open
 * @property {number} days_until_closing
 * @property {boolean} partner_can_provide_feedback
 * @property {boolean} partner_can_upload_files
 * @property {boolean} monitor_can_provide_feedback
 * @property {boolean} monitor_can_upload_files
 * @property {boolean} msp_can_provide_feedback
 * @property {boolean} msp_can_upload_files
 * @property {boolean} is_claim_review_period
 */

/**
 * A entryState object representing the status of a claim period.
 * @typedef {Object} EntryState
 * @property {Object} classes - An object containing CSS classes for text and background.
 * @property {string} classes.text - The CSS class for the text color.
 * @property {string} classes.background - The CSS class for the background color.
 * @property {Object} badge - An object containing the badge type and text.
 * @property {string} badge.type - The type of the badge (e.g., "success", "grey").
 * @property {string} badge.text - The text to display on the badge (e.g., "Open", "Unavailable").
 */
import { userProjectMixin } from "../../mixins/userProject";
export default {
  name: "ProjectViewClaimIndex",
  mixins: [userProjectMixin],
  computed: {
    /**
     * Returns the list of claim period entries from the component's state.
     * @returns {ClaimEntry[]} - An array of claim period entries.
     */
    entries() {
      return this.state.claim_periods;
    },

    /**
     * Returns the current open claim period entry, if any.
     * @returns {ClaimEntry|null} - The current open claim period entry or null if none are open.
     */
    current() {
      return this.entries.find(entry => entry.is_open);
    },

    /**
     * Returns the next upcoming claim period entry that is not currently open.
     * @returns {ClaimEntry|null} - The next upcoming claim period entry or null if none are available.
     */
    next() {
      return this.entries.filter(entry => !entry.is_open)?.[0];
    }
  },
  created() {
    document.title = `Project ${this.state.project.ref} Claims :: ${document.title}`;
  },
  methods: {
    getLatestClaimEntryForWindow(entry) {
      return this
        .state
        .claims
        .filter(claim => claim.period_path === entry.claim_period_path)
        .sort((a, b) => b.version - a.version)?.[0];
    },

    newClaimEntryState(hasClaim, classesText, classesBackground, classesRow, badgeType, badgeText) {
      return {
        hasClaim,
        classes: {
          text: classesText,
          background: classesBackground,
          row: classesRow
        },
        badge: {
          type: badgeType,
          text: badgeText
        }
      };
    },
    /**
     * Returns the badge type for a given entry.
     *
     * @param {ClaimEntry} entry  - The entry object containing claim period details.
     * @returns {EntryState} - The entry state object containing the badge type and text.
     */
    entryState(entry) {
      const latestClaimEntry = this.getLatestClaimEntryForWindow(entry);
      const cwo = entry.claim_window_open;
      if (!latestClaimEntry) {
        if (!cwo) {
          return this.newClaimEntryState(false, "text-grey-600", "bg-grey-100", "", "grey", "Unavailable");
        }
        return this.newClaimEntryState(false, "text-primary-600", "bg-primary-100", "hover:bg-primary-50", "primary", "Open");
      }

      if(!cwo && !latestClaimEntry.is_in_progress) {
        return this.newClaimEntryState(true, "text-grey-600", "bg-grey-100", "hover:bg-grey-50", "grey", "Expired");
      }

      switch(latestClaimEntry.status) {
        case 0:
          return this.newClaimEntryState(true, "text-primary-600", "bg-primary-100", "hover:bg-primary-50", "primary", latestClaimEntry.status_label);
        case 1:
        case 2:
          return this.newClaimEntryState(true, "text-neutral-600", "bg-neutral-100", "hover:bg-neutral-50", "neutral", latestClaimEntry.status_label);
        case 3:
          return this.newClaimEntryState(true, "text-positive-600", "bg-positive-100", "hover:bg-positive-50", "positive", latestClaimEntry.status_label);
        case 4:
          return this.newClaimEntryState(true, "text-secondary-600", "bg-secondary-100", "hover:bg-secondary-50", "secondary", latestClaimEntry.status_label);
        case 5:
          return this.newClaimEntryState(true, "text-negative-600", "bg-negative-100", "hover:bg-negative-50", "negative", latestClaimEntry.status_label);
        case 6:
        default:
          return this.newClaimEntryState(true, "text-grey-600", "bg-grey-100", "", "grey", latestClaimEntry.status_label);
      }

    },

    /**
     * Returns a description of the claim period schedule for a given entry.
     *
     * @param {ClaimEntry} entry - The entry object containing claim period details.
     * @returns {string} - A description of the claim period schedule.
     */
    scheduleDescription(entry) {
      const { days_until_open, days_until_closing } = entry;
      const date = this.format(this.parseISO(entry.open_date_schedule), "MMMM yyyy");

      if (days_until_open > 0) {
        return `Claims for ${date} open in ${entry.days_until_open} days`;
      }

      if (days_until_closing > 0) {
        return `Claims for ${date} close in ${entry.days_until_closing} days`;
      }

      const claim = this.getLatestClaimEntryForWindow(entry);
      if (claim) {
        return claim.is_in_progress ? `Continue claim for ${date}` : `Claim request expired for ${date}`;
      }

      return `Claims for ${date} has closed`;
    }
  }
};
</script>
